import { render, staticRenderFns } from "./PanelCardSlider.vue?vue&type=template&id=385bdc49&scoped=true&"
import script from "./PanelCardSlider.vue?vue&type=script&lang=js&"
export * from "./PanelCardSlider.vue?vue&type=script&lang=js&"
import style0 from "./PanelCardSlider.vue?vue&type=style&index=0&id=385bdc49&lang=scss&"
import style1 from "./PanelCardSlider.vue?vue&type=style&index=1&id=385bdc49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385bdc49",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nicholashaskell/Local/kicknic/app/public/wp-content/themes/kicknic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('385bdc49')) {
      api.createRecord('385bdc49', component.options)
    } else {
      api.reload('385bdc49', component.options)
    }
    module.hot.accept("./PanelCardSlider.vue?vue&type=template&id=385bdc49&scoped=true&", function () {
      api.rerender('385bdc49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/scripts/components/panels/PanelCardSlider.vue"
export default component.exports